import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_TEAK_PROTECTION, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemTeakProtectionMaybe = props => {
  const { lineItems, isCustomer, intl } = props;

  const teakLineItem = lineItems.find(
    item => item.code === LINE_ITEM_TEAK_PROTECTION && !item.reversal
  );

  if (!isCustomer || !teakLineItem) {
    return null;
  }

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.refundProtection" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, teakLineItem.lineTotal)}</span>
    </div>
  );
};

LineItemTeakProtectionMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isCustomer: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemTeakProtectionMaybe;
